<sd-modal>
  <div class="wrapper">
    <div class="header">Заказ можно забрать на складах</div>
    <div class="warehouses-wrapper">
      <div class="scheme"><img [src]="scheme" alt="scheme" /></div>
      <div class="warehouses" *ngIf="warehouses.length > 0">
        <div class="warehouse" *ngFor="let warehouse of warehouses">
          <div class="title" (click)="toggleWarehouse(warehouse)">
            <div class="button-collapse">
              <cx-icon [ngClass]="{ flipped: warehouse.visible }" type="ARROW_EXPAND"></cx-icon>
            </div>
            <div>{{ warehouse.name }}</div>
            <div>
              ({{ warehouse.orderEntries.length }}
              {{ warehouse.orderEntries.length | i18nPlural: { one: 'товар', few: 'товара', many: 'товаров' } }})
            </div>
          </div>
          <div class="items" *ngIf="warehouse.visible">
            <div class="item" *ngFor="let order of warehouse.orderEntries">
              <div class="item-img" *ngIf="order.product?.images">
                <div><cx-media [container]="order.product.images"></cx-media></div>
              </div>

              <div class="item-name">{{ order.product?.name || order.productName }}</div>
              <div class="item-unit">{{ order.quantity + ' ' + order.saleUnit.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</sd-modal>
